<template>
  <transition name="modal-fade">
    <div class="modal-backdrop-new">
      <div
        class="modal-new"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header class="modal-header-new" id="modalTitle">
          <slot name="header"></slot>
        </header>
        <section class="modal-body-new" style="padding:0px;" id="modalDescription">
          <slot name="body">
            <div>
              <label v-html="message"
                class="mb-3"
                style="width: 580px; padding-left:20px;padding-top: 10px;"
              ></label>
            </div>
          </slot>
        </section>
        <footer class="modal-footer-new">          
          <div class="btn-container right" style="margin-top: 0px; height:30px">
            <a
              class="alpha-btn"
              style="color: white; cursor: pointer;width: 200px; text-align: center"
              @click="onCancelModal"
            >Close</a>
          </div>
        </footer>
      </div>
    </div>
  </transition>
</template>


<script>

export default {
  name: 'alertModal',
  props: ['cancelModal', 'message'],
  data() {
    return {};
  },

  methods: {
    close() {
      this.cancelModal();
    },
    onCancelModal() {
      this.cancelModal();
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/components/Dialogs/alertModal.vue